export const CommonConstants = {
    VOYA_WL: 'WLCoverage',
    NATIONWIDE_PET: 'Pet Insurance',
}

export const productSpecificIdentifier = {
    CI_AFLAC: "CIAFLAC#0"
}

export const dependentCodes = ['cCoveredSpouse', 'cCoveredChild', 'cOtherDependant', 'cOtherRelation']
